import { PrimaryButton } from "components/Button/style";
import { useState } from "react";
import {
  TIPO_SOLICITACAO_PLACA,
  TipoSolicitacaoPlaca,
} from "../../constants/tipoSolicitacaoPlaca";
import { useMoverTipoSolicitacao } from "../../hooks/useMoverTipoSolicitacao";
import { MoverTipoModal } from "../../modals/MoverTipoModal";
import { ModalRetorno, useModalRetorno } from "../ModalRetorno";

const NOME_DO_TIPO: Record<TipoSolicitacaoPlaca, string> = {
  [TIPO_SOLICITACAO_PLACA.INOVA]: "Inova",
  [TIPO_SOLICITACAO_PLACA.TERCEIROS]: "Terceiros",
};

interface IProps {
  idsSolicitacao: number[];
  destino: TipoSolicitacaoPlaca;
  onMovidas: () => void;
}

export function BotaoMoverTipo({ idsSolicitacao, destino, onMovidas }: IProps) {
  const { mover, movendo } = useMoverTipoSolicitacao(destino);
  const nome = NOME_DO_TIPO[destino];
  const titulo = `Mover para ${nome}`;
  const [mostrarModal, setMostrarModal] = useState(false);
  const { mostrarRetorno, propsModalRetorno } = useModalRetorno();

  async function moverSelecionadas() {
    const resultado = await mover(idsSolicitacao);
    if (!resultado) return;

    setMostrarModal(false);
    onMovidas();
    if (resultado.alterados === 0) {
      mostrarRetorno(
        titulo,
        "Nenhuma placa movida: as selecionadas já não estavam pendentes.",
        "aviso"
      );
      return;
    }
    mostrarRetorno(titulo, `Placas movidas para ${nome} com sucesso!`);
  }

  return (
    <>
      <PrimaryButton
        type="button"
        outline
        variante="primary"
        disabled={idsSolicitacao.length === 0 || movendo}
        onClick={() => setMostrarModal(true)}
      >
        {titulo}
      </PrimaryButton>
      <MoverTipoModal
        show={mostrarModal}
        titulo={titulo}
        quantidade={idsSolicitacao.length}
        nomeDestino={nome}
        carregando={movendo}
        onCancelar={() => setMostrarModal(false)}
        onConfirmar={moverSelecionadas}
      />
      <ModalRetorno {...propsModalRetorno} />
    </>
  );
}
